module.exports = __webpack_public_path__ + "img/7e7aa78c.jpg";